import MedicineShortcutRepository from '@/js/repositories/MedicineShortcutRepository'

const state = {
	medicineShortcuts: [],
}

const getters = {

}

const actions = {
	async getMedicineShortcuts({ commit }) {
		await MedicineShortcutRepository.getMedicineShortcuts()
			.then(res => {
				commit('MEDICINE_SHORTCUT_INFO', JSON.parse(JSON.stringify(res.data.data)))
			})
			.catch(error => {
				commit('MEDICINE_SHORTCUT_INFO', '')
			})
	}
}

const mutations = {
	MEDICINE_SHORTCUT_INFO(state, data) {
		state.medicineShortcuts = data
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
